import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../generic-components/Heading';
import { LiliCheckbox, LiliCheckboxSize } from '../../../DesignSystem/LiliCheckbox/LiliCheckbox';

interface IProps {
  checkboxValue: boolean;
  handleCheck: (isChecked: boolean) => void;
  customTitle?: string;
}

const RememberMfaLogin = ({
  checkboxValue, handleCheck, customTitle,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='flex items-center mb-[8px] relative'>
      <LiliCheckbox
        id='mfaCheckbox'
        containerClassName='mr-[8px]'
        size={LiliCheckboxSize.SMALL}
        checked={checkboxValue}
        onCheckedChange={handleCheck}
      />
      <Heading
        title={customTitle || t('VERIFICATION_CODE_REMEMBER_ME')}
        className='text-bw06 font-metric text-[12px]'
      />
    </div>
  );
};

export default RememberMfaLogin;
